import { ISalePageDetailV2Response } from '@/api/types';
import { SellerInfoSection } from '@/app/sales/components/sellerInfo';
import { Column, Element } from '@vuddy/components';
import * as styles from './gachaProbability.css';

interface IGachaContentNoticeProps {
  salePageId: number;
  salePage: ISalePageDetailV2Response;
}

const notices1 = [
  '가챠 횟수권은 정해진 기한 내에 사용이 필요한 상품으로 구매 후 청약철회(구매 이후 취소 신청 및 환불)가 불가능합니다.',
  '지급된 콘텐츠는 교환, 환불, 변경이 불가능합니다.',
  '동일한 아이템이 중복 지급될 수 있으며, 중복에 따른 환불도 불가능합니다.',
];

const notices2 = [
  '성인만 구매할 수 있으며, 미성년자(청소년)는 구매가 제한됩니다.',
  '청소년이 구매 시 불이익이 발생할 수 있으며, 이후에도 환불이나 책임을 요구할 수 없습니다.',
];

const notices3 = [
  '각 가챠 상품은 1회권 또는 N회권 단위로 판매됩니다.',
  '보유한 가챠권은 자동으로 사용되며, 한번에 일괄 진행됩니다.',
  '사용하지 않은 가챠권은 판매 종료 시점에 자동 사용 처리되며, 이때의 가챠 결과는 당시 확률표 기준으로 지급됩니다.',
];

const notices4 = [
  '재고 기반 가챠는 남은 수량에 따라 실시간으로 확률이 변동되며, 해당 정보는 가챠 상세 페이지 내 확률 정보 영역에서 확인할 수 있습니다.',
  '고정 확률 가챠는 아이템의 획득 확률이 항상 동일하며, 가챠를 진행할 때마다 동일한 확률이 적용됩니다.',
  '모든 가챠의 확률 정보는 가챠 상세 페이지 내 확률 정보 안내를 통해 제공됩니다.',
];

const notices5 = [
  '대리가챠가 가능한 상품의 경우, 대리가챠 전용 확률이 별도로 적용됩니다.',
  '대리가챠 확률은 별도의 확률표 안내 영역에서 확인할 수 있습니다.',
  '판매 종료일까지 크리에이터가 진행하지 않은 대리가챠는 판매 종료 시점에 일괄 자동 처리되며, 대리가챠 확률이 아닌 일반 확률 안내 표에 고지된 확률이 적용됩니다.',
];

const notices6 = [
  '본 상품의 가챠 확률 정보는 관련 법령 및 디지털 확률형 아이템 가이드라인을 준수하여 제공됩니다.',
];

export const GachaContentNotice = ({
  salePageId,
  salePage,
}: IGachaContentNoticeProps) => {
  return (
    <Column
      padding="padding_base"
      gap="gap_3xl"
      borderRadius="radius_large"
      backgroundColor="whiteQuaternary"
      id="notice">
      <Element typography="titleSmall" color="whitePrimary">
        유의사항
      </Element>
      <SellerInfoSection
        salePageId={salePageId}
        salePage={salePage}
        colorScheme="white"
        initialOpen
      />
      <Column gap="gap_3xl">
        <Column gap="gap_base">
          <Element typography="bodyXsAccent" color="whitePrimary">
            환불 및 청약철회
          </Element>
          <ul className={styles.ul}>
            {notices1.map(notice => (
              <li className={styles.li} key={notice}>
                {notice}
              </li>
            ))}
          </ul>
        </Column>

        <Column gap="gap_base">
          <Element typography="bodyXsAccent" color="whitePrimary">
            이용 대상 제한
          </Element>
          <ul className={styles.ul}>
            {notices2.map(notice => (
              <li className={styles.li} key={notice}>
                {notice}
              </li>
            ))}
          </ul>
        </Column>

        <Column gap="gap_base">
          <Element typography="bodyXsAccent" color="whitePrimary">
            가챠 사용 방식
          </Element>
          <ul className={styles.ul}>
            {notices3.map(notice => (
              <li className={styles.li} key={notice}>
                {notice}
              </li>
            ))}
          </ul>
        </Column>

        <Column gap="gap_base">
          <Element typography="bodyXsAccent" color="whitePrimary">
            확률 정보
          </Element>
          <ul className={styles.ul}>
            {notices4.map(notice => (
              <li className={styles.li} key={notice}>
                {notice}
              </li>
            ))}
          </ul>
        </Column>

        <Column gap="gap_base">
          <Element typography="bodyXsAccent" color="whitePrimary">
            대리 가챠
          </Element>
          <ul className={styles.ul}>
            {notices5.map(notice => (
              <li className={styles.li} key={notice}>
                {notice}
              </li>
            ))}
          </ul>
        </Column>

        <Column gap="gap_base">
          <Element typography="bodyXsAccent" color="whitePrimary">
            기타 안내
          </Element>
          <ul className={styles.ul}>
            {notices6.map(notice => (
              <li className={styles.li} key={notice}>
                {notice}
              </li>
            ))}
          </ul>
        </Column>
      </Column>
    </Column>
  );
};
